import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { DemoState } from './demo/state/demo.state';
import { MsalGuard } from '@azure/msal-angular';
import { UserManagementGuard } from './auth/guards/user-management.guard';
import { AccountingRoles, EntraRoles, GlobalRoles } from '@monorepo/interfaces';

export const routes: Routes = [
    // TODO: Add your own routes here and remove the demo route if not needed
    {
        path: 'demo',
        loadChildren: () => import('./demo/demo.routes').then(r => r.DEMO_ROUTES),
        providers: [provideStates([DemoState])],
        canActivate: [MsalGuard]
    },
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./auth/components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
    },
    {
        path: 'home',
        loadComponent: () => import('./landing-page/landing-page.component').then(c => c.LandingPageComponent),
        canActivate: [UserManagementGuard]
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'users',
        loadChildren: () => import('./user-management/user-management.routes').then(m => m.USER_MANAGEMENT_ROUTES),
        canActivate: [UserManagementGuard],
        data: { roles: [GlobalRoles.SYSTEM_ADMIN, AccountingRoles.LOCAL_ADMIN] }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes),
        canActivate: [UserManagementGuard],
        data: { roles: [GlobalRoles.SYSTEM_ADMIN], entraRoles: [EntraRoles.QUARTERLY_EXPORT] }
    },
    {
        path: 'fleet-management',
        loadChildren: () => import('./fleet-management/fleet-management.routes').then(m => m.fleetManagementRoutes),
        canActivate: [UserManagementGuard],
        data: { roles: [GlobalRoles.SYSTEM_ADMIN, AccountingRoles.SCM, AccountingRoles.ACCOUNTANT] }
    },
    {
        path: 'export',
        loadChildren: () => import('./lars-export/lars-export.routes').then(m => m.LARS_EXPORT_ROUTES),
        canActivate: [UserManagementGuard],
        data: { roles: [GlobalRoles.SYSTEM_ADMIN, AccountingRoles.LOCAL_ADMIN] }
    }
];
